import { useTranslations } from "next-intl"

export function useCallToActionLabel() {
    return useTranslations("useCallToActionLabel")
}

useCallToActionLabel.messages = ["useCallToActionLabel"] as const
